import {createAction} from 'web-app/util/redux/famly-app-helpers';
import {type REPORT_CONFIG} from 'web-app/react/child-development/constants';

import {type TransformedCohortFormData} from './models';

const domain = 'COHORT_COMPARE';

export const {action: addCohort} = createAction(`${domain}/ADD_COHORT`, (cohort: TransformedCohortFormData) => ({
    cohort,
}));

export const {action: removeCohort} = createAction(`${domain}/REMOVE_COHORT`, (id: string) => ({id}));

export const {action: setMode} = createAction(`${domain}/SET_MODE`, (mode: REPORT_CONFIG) => ({mode}));

export const {action: showAddCohortForm} = createAction(`${domain}/SHOW_ADD_COHORT_FORM`, () => ({}));

export const {action: hideAddCohortForm} = createAction(`${domain}/HIDE_ADD_COHORT_FORM`, () => ({}));
